import styled from 'styled-components';

export const Bubble = styled.path`
  color: ${({ theme }) => theme.colors.accent};
`;

export const Text = styled.path`
  color: ${({ theme }) => theme.colors.primary};
`;
